import React from "react";
import { QuickLinkText } from "../../../../global/style";

export default function TextQuickLink({ text, specials, quicklinkStyle }) {
  return <QuickLinkText className="QuickLinkText" specials={specials} quicklinkStyle={quicklinkStyle}>
    {/*return <QuickLinkText specials={specials && text.toLowerCase() === "new search"}>*/}
    <span>{text}</span>
  </QuickLinkText>
}